import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import DulsaCameraSMP from '../../../../components/SMP/DulsaCamera';
import LightArchSMP from '../../../../components/SMP/LightArch';
import Lights18SMP from '../../../../components/SMP/Lights18';
import Lights25SMP from '../../../../components/SMP/Lights25';
import DoubleWideSMP from '../../../../components/SMP/DoubleWide';
import TriggerBoardSMP from '../../../../components/SMP/TriggerBoard';
import ChannelBoardSMP from '../../../../components/SMP/ChannelBoard';
import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

const SIMaintenanceOverview = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/montgomery/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Maintenance</Breadcrumb.Item>
							<Breadcrumb.Item active>Maintenance Procedures</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="Dalsa Camera" className="mb-3">
								<Tab eventKey="Dalsa Camera" title="Dalsa Camera">
									<div class="tab-section" style={{}}>
										<DulsaCameraSMP />
										{/* <div class="right-side">

											<div class="note">
												<p>Important: It is extremely imperative that during the camera replacement the mounting bracket, arm and angle adjustment dials for the camera are not moved, bumped or disturbed as these are in precise set positions. Lock labels have been installed on both of the angle adjustment dials and should not be removed or repositioned during this procedure.</p>
											</div>

											<h5 style={{ marginTop: '10px' }}>CAMERA IP ADDRESSES</h5>
											<p>In the event that one of the cameras needs to be replaced, you will have to set that cameras IP Address to match the unit that is being removed from the system. Below is a table of the IP Addresses of each camera.</p>
											<div class="img-box" style={{ display: 'flex' }}>
												<Table striped bordered hover style={{ margin: '5px' }}>
													<thead>
														<tr>
															<th>Camera #</th>
															<th>IP Address</th>
															<th>GPU Server #</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td>101</td>
															<td>10.1.1.2</td>
															<td>1</td>
														</tr>
														<tr>
															<td>102</td>
															<td>10.1.2.2</td>
															<td>1</td>
														</tr>
														<tr>
															<td>103</td>
															<td>10.1.3.2</td>
															<td>1</td>
														</tr>
														<tr>
															<td>104</td>
															<td>10.1.4.2</td>
															<td>1</td>
														</tr>
														<tr>
															<td>105</td>
															<td>10.1.5.2</td>
															<td>1</td>
														</tr>
														<tr>
															<td>106</td>
															<td>10.1.6.2</td>
															<td>1</td>
														</tr>
														<tr>
															<td>107</td>
															<td>10.1.7.2</td>
															<td>1</td>
														</tr>
														<tr>
															<td>108</td>
															<td>10.1.8.2</td>
															<td>1</td>
														</tr>
														<tr>
															<td>109</td>
															<td>10.1.9.2</td>
															<td></td>
														</tr>
														<tr>
															<td>201</td>
															<td>10.2.1.2</td>
															<td>2</td>
														</tr>
														<tr>
															<td>202</td>
															<td>10.2.2.2</td>
															<td>2</td>
														</tr>
														<tr>
															<td>203</td>
															<td>10.2.3.2</td>
															<td>2</td>
														</tr>
														<tr>
															<td>204</td>
															<td>10.2.4.2</td>
															<td>2</td>
														</tr>
														<tr>
															<td>313</td>
															<td>10.3.9.2</td>
															<td>3</td>
														</tr>
													</tbody>
												</Table>

												<Table striped bordered hover style={{ margin: '5px' }}>
													<thead>
														<tr>
															<th>Camera #</th>
															<th>IP Address</th>
															<th>GPU Server #</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td>314</td>
															<td>10.3.10.2</td>
															<td>3</td>
														</tr>
														<tr>
															<td>315</td>
															<td>10.3.11.2</td>
															<td>3</td>
														</tr>
														<tr>
															<td>316</td>
															<td>10.4.1.2</td>
															<td>4</td>
														</tr>
														<tr>
															<td>317</td>
															<td>10.4.2.2</td>
															<td>4</td>
														</tr>
														<tr>
															<td>318</td>
															<td>10.4.3.2</td>
															<td>4</td>
														</tr>
														<tr>
															<td>319</td>
															<td>10.4.4.2</td>
															<td>4</td>
														</tr>
														<tr>
															<td>320</td>
															<td>10.4.5.2</td>
															<td>4</td>
														</tr>
														<tr>
															<td>321</td>
															<td>10.4.6.2</td>
															<td>4</td>
														</tr>
														<tr>
															<td>322</td>
															<td>10.4.7.2</td>
															<td>4</td>
														</tr>
														<tr>
															<td>323</td>
															<td>10.4.8.2</td>
															<td>4</td>
														</tr>
														<tr>
															<td>324</td>
															<td>10.4.9.2</td>
															<td>4</td>
														</tr>
														<tr>
															<td>325</td>
															<td>10.4.10.2</td>
															<td>4</td>
														</tr>
														<tr>
															<td>326</td>
															<td>10.4.11.2</td>
															<td>4</td>
														</tr>
													</tbody>
												</Table>
											</div> */}
										{/* </div> */}
									</div>
								</Tab>

								<Tab eventKey="Channel Board" title="Channel Board">
									<ChannelBoardSMP />
								</Tab>

								<Tab eventKey="Trigger Board" title="Trigger Board">
									<div class="tab-section" style={{}}>
										<TriggerBoardSMP />
									</div>
								</Tab>

								<Tab eventKey="Light Arch" title="Light Arch">
									<div class="tab-section" style={{}}>
										<LightArchSMP />
									</div>
								</Tab>

								<Tab eventKey="Lights 1-8" title="Lights 1-8">
									<div class="tab-section" style={{}}>
										<Lights18SMP />
									</div>
								</Tab>

								<Tab eventKey="Lights 2-5" title="Lights 2-5">
									<div class="tab-section" style={{}}>
										<Lights25SMP />
									</div>
								</Tab>

								<Tab eventKey="Double Wide Lights" title="Double Wide Lights">
									<div class="tab-section" style={{}}>
										<DoubleWideSMP />
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SIMaintenanceOverview;
